import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import setStickyButtonHeightCssVar from 'commons/setStickyButtonHeightCssVar';
import useScreen from 'hooks/useScreen';

// Takes the elements themselves rather than refs, so that a replaced node
// re-runs the effect and the measurement follows whatever is actually in the document.
const useShowStickyButtons = (addToBagSection, t0) => {
  const $ = _c(5);
  const stickyPriceRow = t0 === undefined ? null : t0;
  const {
    isMobileOrTablet
  } = useScreen();
  const [showStickyButtons, setShowStickyButtons] = useState(false);
  let t1;
  let t2;
  if ($[0] !== addToBagSection || $[1] !== isMobileOrTablet || $[2] !== stickyPriceRow) {
    t1 = () => {
      if (!addToBagSection) {
        setShowStickyButtons(false);
        if (isMobileOrTablet) {
          setStickyButtonHeightCssVar(11);
        }
        return;
      }
      const measure = () => {
        const addToBagSectionRect = addToBagSection.getBoundingClientRect();
        const isLaidOut = addToBagSectionRect.width > 0 || addToBagSectionRect.height > 0;
        const hiddenBelow = stickyPriceRow ? stickyPriceRow.getBoundingClientRect().bottom : 0;
        const hasScrolledPastAddToBag = isLaidOut && addToBagSectionRect.bottom < hiddenBelow;
        setShowStickyButtons(hasScrolledPastAddToBag);
        if (isMobileOrTablet) {
          setStickyButtonHeightCssVar(hasScrolledPastAddToBag ? 100 : 11);
        }
      };
      const scheduledFrame = {
        current: null
      };
      const scheduleMeasure = () => {
        if (scheduledFrame.current !== null) {
          return;
        }
        scheduledFrame.current = requestAnimationFrame(() => {
          scheduledFrame.current = null;
          measure();
        });
      };
      measure();
      window.addEventListener("scroll", scheduleMeasure, {
        passive: true
      });
      window.addEventListener("resize", scheduleMeasure);
      const resizeObserver = typeof ResizeObserver === "function" ? new ResizeObserver(scheduleMeasure) : null;
      resizeObserver?.observe(addToBagSection);
      resizeObserver?.observe(document.body);
      if (stickyPriceRow) {
        resizeObserver?.observe(stickyPriceRow);
      }
      return () => {
        if (scheduledFrame.current !== null) {
          cancelAnimationFrame(scheduledFrame.current);
        }
        window.removeEventListener("scroll", scheduleMeasure);
        window.removeEventListener("resize", scheduleMeasure);
        resizeObserver?.disconnect();
      };
    };
    t2 = [addToBagSection, stickyPriceRow, isMobileOrTablet];
    $[0] = addToBagSection;
    $[1] = isMobileOrTablet;
    $[2] = stickyPriceRow;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return showStickyButtons;
};
export default useShowStickyButtons;